var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#fff"}},[_c('wapHeader'),_c('wapView',{staticStyle:{"margin-top":"70px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }